import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-line-left",
  "use": "icon-line-left-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-line-left\">\n<g id=\"icon-line-left_Direction/line-left\">\n<g id=\"icon-line-left_icon/jiantou\">\n<path id=\"icon-line-left_chevron-down\" d=\"M9.54165 3.5417L10.4609 4.46094L6.92051 8.00132L10.4609 11.5417L9.54165 12.4609L5.08203 8.00132L9.54165 3.5417Z\" fill=\"#282C33\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/line-left.svg
// module id = qxC3
// module chunks = 140